import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function useIsPremium() {
  const { user } = useAuth();
  const plan = user?.effective_plan || "free";
  return plan === "premium" || plan === "lifetime";
}

/** Full-size upgrade prompt shown in place of a Premium-only feature. */
export function PremiumUpsell({ feature = "This feature" }) {
  return (
    <div className="border-2 border-[#A67C00] bg-[#FDFBF7] p-10 lg:p-14 text-center shadow-[6px_6px_0px_#A67C00]" data-testid="premium-upsell">
      <Crown className="w-8 h-8 text-[#A67C00] mx-auto" />
      <h3 className="font-serif text-3xl lg:text-4xl tracking-tight mt-4">{feature} is a Premium feature.</h3>
      <p className="text-sm text-[#6C7565] mt-3 max-w-md mx-auto">
        Upgrade to unlock the AI assistant, voice expense logging and AI spending insights — ₹99/month, or ₹2,499 once for life.
      </p>
      <Link
        to="/pricing"
        data-testid="premium-upsell-cta"
        className="inline-flex items-center gap-2 mt-8 bg-[#A67C00] text-white px-8 py-4 text-xs uppercase tracking-[0.25em] hover:bg-[#1A1F16] transition-colors"
      >
        <Crown className="w-3.5 h-3.5" /> View plans
      </Link>
    </div>
  );
}

/** Wrap Premium-only content: renders children for paying users, the upsell otherwise. */
export function PremiumGate({ feature, children }) {
  const isPremium = useIsPremium();
  if (!isPremium) return <PremiumUpsell feature={feature} />;
  return children;
}
